import { Status } from "@src/constants/integration-provider.model";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import "./status.dropdown.scss";

export function StatusDropdown({
  className,
  onStatusSelected,
  selectedStatus,
}) {
  return (
    <Dropdown
      className={`status-dropdown ${className}`}
      selected={selectedStatus}
      onOptionSelected={onStatusSelected}
    >
      <DropdownButton placeholder="All Statuses" clearEnabled>
        {selectedStatus}
      </DropdownButton>
      <DropdownItems>
        {Object.values(Status).map((status) => (
          <DropdownItem key={status} value={status}>
            {status}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
}
